var getCSSTemplateValue = function getCSSTemplateValue(template, gap) {
  if (gap === void 0) {
    gap = '';
  }

  return Array.from({
    length: template
  }, function () {
    return '1fr';
  }).join(" " + gap + " ");
};

var gridStyles = {
  root: function root(_ref) {
    var props = _ref.props,
        _ref$variables = _ref.variables,
        height = _ref$variables.height,
        width = _ref$variables.width,
        defaultColumnCount = _ref$variables.defaultColumnCount,
        gridGap = _ref$variables.gridGap,
        padding = _ref$variables.padding;
    var rows = props.rows,
        _props$columns = props.columns,
        columns = _props$columns === void 0 ? !props.rows && defaultColumnCount : _props$columns;
    return Object.assign({
      height: height,
      width: width,
      padding: padding,
      gridGap: gridGap,
      display: ['grid', '-ms-grid'],
      justifyContent: 'space-evenly'
    }, rows && !columns && {
      gridAutoFlow: 'column'
    }, {}, rows && {
      gridTemplateRows: getCSSTemplateValue(rows),
      msGridRows: getCSSTemplateValue(rows, gridGap)
    }, {}, columns && {
      gridTemplateColumns: getCSSTemplateValue(columns),
      msGridColumns: getCSSTemplateValue(columns, gridGap)
    }, {
      '& > *': {
        outlineOffset: '-3px'
      }
    });
  }
};
export default gridStyles;
//# sourceMappingURL=gridStyles.js.map
